<template>
  <div>
    <textarea :id="id"></textarea>
  </div>
</template>

<script>

  export default {
    name: 'CKEditor',
    props: [
      'value','id'
    ],
    data () {
      return {
        ckeditor: null
      }
    },
    mounted: function () {
      const self = this;
      // 渲染编辑器
      self.ckeditor = window.CKEDITOR.replace(this.id, {
        extraPlugins: 'image2,uploadimage',
        toolbarGroups: [
          {name: 'clipboard', groups: ['clipboard', 'undo']},
          {name: 'document', groups: ['mode', 'document', 'doctools']},
          {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
          {name: 'forms', groups: ['forms']},
          {name: 'styles', groups: ['styles']},
          {name: 'colors', groups: ['colors']},
          '/',
          {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
          {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
          {name: 'links', groups: ['links']},
          {name: 'insert', groups: ['insert','Image']},
          {name: 'tools', groups: ['tools']},
          '/',
          {name: 'others', groups: ['others']},
          {name: 'about', groups: ['about']}
        ],
        font_names: '宋体/宋体;黑体/黑体;仿宋/仿宋_GB2312;楷体/楷体_GB2312;隶书/隶书;幼圆/幼圆;微软雅黑/微软雅黑;思源雅黑/思源雅黑',
        image2_alignClasses : [ 'image-left', 'image-center', 'image-right' ],
        image2_captionedClass : 'image-captioned',
        filebrowserBrowseUrl: '/apps/ckfinder/3.4.5/ckfinder.html',
        filebrowserImageBrowseUrl: getPictureUrl() + 'file/attachment/upload/home',
        filebrowserImageUploadUrl: getPictureUrl() + 'file/attachment/upload/home',
        removeDialogTabs: 'image:advanced;link:advanced',
        uploadUrl: getPictureUrl() + 'file/attachment/upload/home',
        removeButtons: 'PasteText,Save,NewPage,Print,Templates,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Blockquote,CreateDiv,BidiRtl,BidiLtr,Anchor,Flash,Table,Iframe,About,ShowBlocks,Replace,Find'
    });

      // 监听内容变更事件
      self.ckeditor.on('change', function () {
        console.log('change', self.ckeditor.getData());
        self.$emit('input', self.ckeditor.getData())
      });

      self.ckeditor.on('click', function (e) {
        console.log('click event from attaching to the editor');
      });

      self.ckeditor.on( 'fileUploadResponse', function( evt ) {
        evt.stop();
        var fileLoader = evt.data.fileLoader,
          xhr = fileLoader.xhr,
          data = evt.data;
        var response = JSON.parse( xhr.responseText );
        data.url = getPictureUrl()  + "file/attachment/download/" + response.fileId;
        return true;
      });
    },
    watch: {
      // 监听prop的变化，更新ckeditor中的值
      value: function () {
        if (this.value !== this.ckeditor.getData()) {
            setTimeout(()=>{
              this.ckeditor.setData(this.value)
            }, 400)
        }
      }
    },
    // 销毁组件前，销毁编辑器
    destroyed () {
      for (this.id in CKEDITOR.instances) {
        CKEDITOR.instances[this.id].destroy()
      }
    }
  }
</script>
<style>
.image-center{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/common/editor/CKEditor.vue